import React, { useState, useEffect } from 'react'
import { Box, Select, Flex, Group, Button, Avatar, Text } from '@mantine/core'
import { validation } from '../../../../../plugins/validation'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { getListUsers } from '../../../../../services/users'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { IconCheck } from '@tabler/icons-react'

const defaultVal = {
  user_id: '',
}

const formValidation = {
  user_id: {
    isError: false,
    message: ''
  }
}

const FormAdjustOrderBy = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [userList, setUserList] = useState([])
  const [searchUser, setSearchUser] = useState('')

  const submitOrderBy = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const isError = validation(form, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      user_id: Number(form.user_id)
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListUsers = async (userId) => {
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchUser,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchUser])

  useEffect(() => {
    if (summary) {
      handleGetListUsers(summary.userId)
      handleSetForm(summary)
    }
    // eslint-disable-next-line
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      user_id: `${value.userId}`
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='user_id'
          value={formData.user_id}
          label='Order By'
          placeholder='Select Order By'
          data={userList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeForm('user_id', val)}
          error={validationForm.user_id.isError ? `${validationForm.user_id.message}` : ''}
          size='xs'
          searchable
          searchValue={searchUser}
          onSearchChange={setSearchUser}
          nothingFoundMessage="No User Found"
          clearable
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitOrderBy(formData)}>Change</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustOrderBy